import {useState, useEffect} from 'react';
import {queryLastDatapointsValue, type Asset} from '@deviceinsight/ng-ui-api-client';

import {
	DATAPOINT_BOOTLOADER_VERSION,
	DATAPOINT_CERTIFICATE_EXPIRATION,
	DATAPOINT_DATA_MATRIX_CODE,
	DATAPOINT_FIRMWARE_VERSION,
	DATAPOINT_GATEWAY,
	DATAPOINT_HARDWARE_REVISION,
	DATAPOINT_IP_ADRESS,
	DATAPOINT_MAC_ADRESS,
	DATAPOINT_OPEN_SSL_VERSION,
	DATAPOINT_OS_VERSION,
	DATAPOINT_PART_NUMBER,
	DATAPOINT_SERIAL_NUMBER,
	DATAPOINT_SUBNET,
	DATAPOINT_WIFI_CHANNEL,
	DATAPOINT_WIFI_SIGNAL_STRENGTH,
	DATAPOINT_WIFI_SSID,
	DATAPOINT_APPLICATION_VERSION,
	DATAPOINT_DESIRED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_BUNDLE_ID,
	DATAPOINT_REPORTED_JOBS_VERSION_ID,
	DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER,
	DATAPOINT_REPORTED_JOBS_UPDATE_STATUS
} from '../../../../../modules/common/consts';
import type {AssetInfoData} from '../types';

type AssetInfoDataWithLoadingInfo = {
	assetData: AssetInfoData;
	loading: boolean;
};

const useAssetInfoData = (asset: Asset) => {
	const [assetInfoData, setAssetInfoData] = useState<AssetInfoDataWithLoadingInfo>({
		assetData: {},
		loading: true
	});

	useEffect(() => {
		Promise.all([
			queryLastDatapointsValue(
				asset.urn,
				[
					DATAPOINT_PART_NUMBER,
					DATAPOINT_SERIAL_NUMBER,
					DATAPOINT_DATA_MATRIX_CODE,
					DATAPOINT_MAC_ADRESS,
					DATAPOINT_HARDWARE_REVISION,
					DATAPOINT_OS_VERSION,
					DATAPOINT_FIRMWARE_VERSION,
					DATAPOINT_BOOTLOADER_VERSION,
					DATAPOINT_OPEN_SSL_VERSION,
					DATAPOINT_WIFI_SSID,
					DATAPOINT_WIFI_SIGNAL_STRENGTH,
					DATAPOINT_WIFI_CHANNEL,
					DATAPOINT_IP_ADRESS,
					DATAPOINT_SUBNET,
					DATAPOINT_GATEWAY,
					DATAPOINT_CERTIFICATE_EXPIRATION,
					DATAPOINT_APPLICATION_VERSION,
					DATAPOINT_DESIRED_JOBS_JOB_ID,
					DATAPOINT_REPORTED_JOBS_JOB_ID,
					DATAPOINT_REPORTED_JOBS_BUNDLE_ID,
					DATAPOINT_REPORTED_JOBS_VERSION_ID,
					DATAPOINT_REPORTED_JOBS_UPDATE_STATUS
				],
				'TEXT'
			),
			queryLastDatapointsValue(asset.urn, [DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER], 'LONG')
		]).then(([textData, longData]) => {
			const data = [...textData.asset.datapoints, ...longData.asset.datapoints];
			const assetData: AssetInfoData = {};
			data.forEach((dp) => {
				const value = dp.values.at(0);
				if (value) {
					assetData[dp.name] = {
						timestamp: new Date(value[0]).getTime(),
						value: value[1]
					};
				}
			});

			setAssetInfoData({assetData, loading: false});
		});
	}, [asset]);

	return assetInfoData;
};

export default useAssetInfoData;
